import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function BrandGuidelinesPage() {
  useEffect(() => {
    document.title = 'Brand & Content Guidelines | NinjAthlete';
  }, []);

  return (
    <div className="brand-guidelines" data-testid="brand-guidelines-page">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@400;500;600;700&family=Inter:wght@300;400;500;600&display=swap');
        .brand-guidelines { font-family: 'Inter', 'Arial', sans-serif; background: #fff; color: #0A0A0A; font-size: 16px; line-height: 1.7; }
        .bg-cover { background: #0A0A0A; color: #fff; min-height: 100vh; display: flex; flex-direction: column; justify-content: center; padding: 80px 100px; position: relative; overflow: hidden; }
        .bg-cover::before { content: ''; position: absolute; top: 0; right: 0; width: 40%; height: 100%; background: #D42B2B; clip-path: polygon(25% 0%, 100% 0%, 100% 100%, 0% 100%); opacity: 0.08; }
        .bg-page { max-width: 900px; margin: 0 auto; padding: 80px 60px; }
        @media(max-width:700px) { .bg-page { padding: 40px 24px; } .bg-cover { padding: 40px 24px; } }
        .bg-section-label { font-family: 'Oswald',sans-serif; font-size: 11px; letter-spacing: 4px; text-transform: uppercase; color: #D42B2B; margin-bottom: 8px; }
        .bg-section-title { font-family: 'Oswald',sans-serif; font-size: 42px; font-weight: 700; text-transform: uppercase; color: #0A0A0A; line-height: 1.1; margin-bottom: 32px; }
        .bg-section-rule { width: 60px; height: 3px; background: #D42B2B; margin-bottom: 48px; }
        .bg-chapter-break { border-top: 1px solid #E0E0E0; padding-top: 80px; margin-top: 80px; }
        .bg-body-text { font-size: 15px; color: #333; line-height: 1.8; margin-bottom: 24px; }
        .bg-highlight { background: #FFF5F5; border-left: 4px solid #D42B2B; padding: 20px 28px; margin: 24px 0; font-size: 14px; color: #444; line-height: 1.8; }
        .bg-manifesto { background: #0A0A0A; color: #fff; padding: 60px; margin: 40px 0; position: relative; overflow: hidden; }
        .bg-manifesto::before { content: '"'; font-family: 'Oswald',sans-serif; font-size: 300px; color: #D42B2B; opacity: 0.06; position: absolute; top: -60px; left: 20px; line-height: 1; }
        .bg-manifesto p { font-family: 'Oswald',sans-serif; font-size: 22px; font-weight: 400; line-height: 1.7; color: #fff; position: relative; z-index: 1; margin-bottom: 16px; }
        .bg-manifesto strong { color: #D42B2B; }
        .bg-pillars-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 24px; margin: 40px 0; }
        @media(max-width:600px) { .bg-pillars-grid { grid-template-columns: 1fr; } }
        .bg-pillar-card { border: 1px solid #E0E0E0; padding: 32px; position: relative; border-left: 4px solid #D42B2B; }
        .bg-pillar-num { font-family: 'Oswald',sans-serif; font-size: 11px; letter-spacing: 3px; color: #D42B2B; text-transform: uppercase; margin-bottom: 8px; }
        .bg-pillar-title { font-family: 'Oswald',sans-serif; font-size: 22px; font-weight: 700; text-transform: uppercase; color: #0A0A0A; margin-bottom: 12px; }
        .bg-pillar-desc { font-size: 14px; color: #6B6B6B; line-height: 1.7; }
        .bg-color-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 16px; margin: 40px 0; }
        @media(max-width:600px) { .bg-color-grid { grid-template-columns: 1fr 1fr; } }
        .bg-color-swatch { border: 1px solid #E0E0E0; overflow: hidden; }
        .bg-color-block { height: 100px; }
        .bg-color-info { padding: 16px; }
        .bg-color-name { font-family: 'Oswald',sans-serif; font-size: 13px; font-weight: 600; text-transform: uppercase; letter-spacing: 1px; color: #0A0A0A; margin-bottom: 4px; }
        .bg-color-hex { font-size: 12px; color: #6B6B6B; font-family: monospace; }
        .bg-color-use { font-size: 11px; color: #6B6B6B; margin-top: 4px; }
        .bg-voice-table { width: 100%; border-collapse: collapse; margin: 32px 0; font-size: 14px; }
        .bg-voice-table th { background: #0A0A0A; color: #fff; font-family: 'Oswald',sans-serif; font-size: 11px; letter-spacing: 2px; text-transform: uppercase; padding: 14px 20px; text-align: left; }
        .bg-voice-table td { padding: 14px 20px; border-bottom: 1px solid #E0E0E0; color: #0A0A0A; line-height: 1.6; }
        .bg-voice-table tr:nth-child(even) td { background: #F5F5F5; }
        .bg-voice-table td:first-child { font-weight: 600; font-size: 13px; color: #D42B2B; font-family: 'Oswald',sans-serif; text-transform: uppercase; letter-spacing: 1px; white-space: nowrap; }
        .bg-type-sample { background: #F5F5F5; padding: 40px; margin: 24px 0; border-left: 4px solid #D42B2B; }
        .bg-type-label { font-size: 11px; letter-spacing: 3px; text-transform: uppercase; color: #6B6B6B; margin-bottom: 12px; }
        .bg-copy-card { border: 1px solid #E0E0E0; margin: 32px 0; overflow: hidden; }
        .bg-copy-header { background: #0A0A0A; color: #fff; padding: 16px 24px; display: flex; justify-content: space-between; align-items: center; }
        .bg-copy-title { font-family: 'Oswald',sans-serif; font-size: 13px; letter-spacing: 2px; text-transform: uppercase; }
        .bg-copy-tag { font-size: 11px; background: #D42B2B; color: #fff; padding: 3px 10px; letter-spacing: 1px; font-family: 'Oswald',sans-serif; text-transform: uppercase; }
        .bg-copy-body { padding: 32px; font-size: 15px; line-height: 1.8; color: #0A0A0A; }
        .bg-copy-body p { margin-bottom: 16px; }
        .bg-taglines-list { list-style: none; margin: 24px 0; padding: 0; }
        .bg-taglines-list li { padding: 16px 24px; border-left: 3px solid #D42B2B; margin-bottom: 12px; background: #F5F5F5; font-family: 'Oswald',sans-serif; font-size: 18px; font-weight: 600; text-transform: uppercase; letter-spacing: 1px; color: #0A0A0A; }
        .bg-logo-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 24px; margin: 32px 0; }
        .bg-logo-box { padding: 40px; display: flex; align-items: center; justify-content: center; border: 1px solid #E0E0E0; }
        .bg-logo-box.dark { background: #0A0A0A; }
        .bg-logo-text { font-family: 'Oswald',sans-serif; font-size: 32px; font-weight: 700; text-transform: uppercase; letter-spacing: 2px; }
        .bg-topic-grid { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 16px; margin: 32px 0; }
        @media(max-width:600px) { .bg-topic-grid { grid-template-columns: 1fr; } }
        .bg-topic-chip { background: #0A0A0A; color: #fff; padding: 10px 18px; font-family: 'Oswald',sans-serif; font-size: 12px; letter-spacing: 2px; text-transform: uppercase; text-align: center; border-left: 3px solid #D42B2B; }
        .bg-audience-grid { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 24px; margin: 32px 0; }
        @media(max-width:700px) { .bg-audience-grid { grid-template-columns: 1fr; } }
        .bg-audience-card { padding: 28px; border: 1px solid #E0E0E0; }
        .bg-audience-name { font-family: 'Oswald',sans-serif; font-size: 16px; font-weight: 700; text-transform: uppercase; color: #0A0A0A; margin-bottom: 8px; }
        .bg-audience-desc { font-size: 13px; color: #6B6B6B; line-height: 1.7; }
        .bg-h3 { font-family: 'Oswald',sans-serif; font-size: 20px; font-weight: 700; text-transform: uppercase; color: #0A0A0A; margin: 32px 0 12px; letter-spacing: 1px; }
        .bg-footer { background: #0A0A0A; color: #555; text-align: center; padding: 48px; font-family: 'Oswald',sans-serif; font-size: 11px; letter-spacing: 3px; text-transform: uppercase; margin-top: 0; }
        .bg-partner-cta { background: #0A0A0A; padding: 80px 60px; text-align: center; border-top: 1px solid #1A1A1A; position: relative; overflow: hidden; }
        .bg-partner-cta::before { content: ''; position: absolute; inset: 0; background: radial-gradient(ellipse at center, rgba(212,43,43,0.12) 0%, transparent 70%); pointer-events: none; }
        @media(max-width:700px) { .bg-partner-cta { padding: 60px 24px; } }
        .bg-cta-label { font-family: 'Oswald',sans-serif; font-size: 11px; letter-spacing: 4px; text-transform: uppercase; color: #D42B2B; margin-bottom: 20px; }
        .bg-cta-title { font-family: 'Oswald',sans-serif; font-size: 52px; font-weight: 700; text-transform: uppercase; color: #fff; line-height: 1.05; margin-bottom: 20px; }
        @media(max-width:700px) { .bg-cta-title { font-size: 36px; } }
        .bg-cta-sub { font-size: 15px; color: #888; max-width: 520px; margin: 0 auto 40px; line-height: 1.8; }
        .bg-cta-btn { display: inline-block; background: #D42B2B; color: #fff; font-family: 'Oswald',sans-serif; font-size: 14px; font-weight: 600; letter-spacing: 3px; text-transform: uppercase; padding: 18px 48px; text-decoration: none; position: relative; z-index: 1; transition: background 0.2s, transform 0.2s; }
        .bg-cta-btn:hover { background: #b82020; transform: translateY(-2px); }
        .bg-cta-divider { width: 60px; height: 3px; background: #D42B2B; margin: 0 auto 40px; }
      `}</style>

      {/* Cover */}
      <div className="bg-cover">
        <div style={{ fontFamily: 'Oswald,sans-serif', fontSize: 11, letterSpacing: 4, textTransform: 'uppercase', color: '#D42B2B', marginBottom: 24 }}>Brand & Content Guidelines — 2025</div>
        <div style={{ fontFamily: 'Oswald,sans-serif', fontSize: 72, fontWeight: 700, lineHeight: 1, textTransform: 'uppercase', marginBottom: 8 }}>
          Ninj<span style={{ color: '#D42B2B' }}>A</span>thlete
        </div>
        <div style={{ fontFamily: 'Oswald,sans-serif', fontSize: 28, fontWeight: 400, color: '#888', letterSpacing: 2, textTransform: 'uppercase', marginBottom: 40 }}>
          The Code of the Optimized Athlete
        </div>
        <div style={{ width: 80, height: 3, background: '#D42B2B', marginBottom: 40 }} />
        <p style={{ fontSize: 16, color: '#BFBFBF', maxWidth: 520, lineHeight: 1.8, marginBottom: 60 }}>
          This document defines the voice, visual identity, content philosophy, and brand ethos of NinjAthlete — the platform for athletes who refuse to accept average. For use by team members, content creators, and agency partners.
        </p>
        <div style={{ fontFamily: 'Oswald,sans-serif', fontSize: 12, letterSpacing: 2, color: '#555', textTransform: 'uppercase' }}>
          ninjathlete.com | Confidential | 2025
        </div>
      </div>

      {/* Table of Contents */}
      <div className="bg-page">
        <div className="bg-section-label">Navigation</div>
        <div className="bg-section-title">What's Inside</div>
        <div className="bg-section-rule" />
        <table className="bg-voice-table">
          <thead><tr><th>#</th><th>Section</th></tr></thead>
          <tbody>
            {['The NinjAthlete Ethos & Manifesto','Brand Story & Origin','Core Pillars','Target Audience','Visual Identity — Colors & Typography','Logo Usage','Voice & Tone','Content Strategy & Topics','Taglines & Messaging','Influencer Outreach Copy','Package Insert Card Copy','Usage Rules & Do\'s/Don\'ts'].map((s,i) => (
              <tr key={s}><td>{String(i+1).padStart(2,'0')}</td><td>{s}</td></tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* 01 — Ethos */}
      <div className="bg-page bg-chapter-break">
        <div className="bg-section-label">01 — Brand Ethos</div>
        <div className="bg-section-title">The NinjAthlete<br/>Manifesto</div>
        <div className="bg-section-rule" />
        <p className="bg-body-text">The word <strong>ninja</strong> doesn't just mean stealth. It means mastery acquired through obsession. The original ninja — the <em>shinobi</em> — were not defined by brute force. They were the most disciplined, most adaptable, and most strategically intelligent operators in history.</p>
        <p className="bg-body-text">An <strong>athlete</strong> is one who is proficient in activity or physical exercise — someone who has dedicated themselves to the pursuit of physical excellence through consistent effort and intelligent training.</p>
        <p className="bg-body-text">Together, <strong>NinjAthlete</strong> is the convergence of two philosophies: the ancient discipline of mastery and the modern science of peak performance.</p>

        <div className="bg-manifesto">
          <p>You are not training for average. You are not optimizing for comfort. You are not settling for the body, the mind, or the life that default biology gives you.</p>
          <p>You are <strong>choosing mastery</strong>. Deliberately. Daily.</p>
          <p>A NinjAthlete is defined by the relentless compounding of marginal improvements — the <strong>Kaizen mindset</strong> applied to every system in the body.</p>
          <p>We train smarter. We recover harder. We optimize everything that can be optimized, and we <strong>never stop asking what's possible.</strong></p>
          <p><strong>Gear up. Show up. Optimize everything.</strong></p>
        </div>
      </div>

      {/* 02 — Brand Story */}
      <div className="bg-page bg-chapter-break">
        <div className="bg-section-label">02 — Brand Story</div>
        <div className="bg-section-title">Where We<br/>Come From</div>
        <div className="bg-section-rule" />
        <p className="bg-body-text">NinjAthlete was born from a simple obsession: <em>what happens when you combine ancient warrior discipline with cutting-edge performance science?</em></p>
        <p className="bg-body-text">Today, NinjAthlete is one of the most comprehensive performance optimization resources available. We cover peptide therapy, HYROX training, biohacking protocols, longevity science, and evidence-based nutrition — all filtered through a single lens: <strong>what actually works, backed by peer-reviewed science.</strong></p>
        <div className="bg-highlight"><strong>The origin phrase:</strong> "Don't settle for mediocrity. Embrace the darkness, the discipline, the ninja within. Gear up, show up, and unleash your inner badass."</div>
        <p className="bg-body-text">Founded by Daniel Rivas (Ninja) — a Certified Digital Marketing Professional, HYROX competitor (59:51 finish at HYROX Dallas), and longtime biohacker — NinjAthlete is built by someone who lives the protocols.</p>
      </div>

      {/* 03 — Core Pillars */}
      <div className="bg-page bg-chapter-break">
        <div className="bg-section-label">03 — Brand Pillars</div>
        <div className="bg-section-title">What We<br/>Stand For</div>
        <div className="bg-section-rule" />
        <div className="bg-pillars-grid">
          {[
            { num: '01', title: 'Kaizen', desc: 'Continuous improvement — the compounding effect of getting 1% better every single day.' },
            { num: '02', title: 'Science First', desc: 'Every protocol is rooted in peer-reviewed research. We cut through the broscience.' },
            { num: '03', title: 'Stoic Discipline', desc: 'Discipline is the system that makes excellence inevitable.' },
            { num: '04', title: 'Strategic Mastery', desc: 'The ninja was the smartest, not the strongest. Train strategically.' },
            { num: '05', title: 'Radical Curiosity', desc: 'We challenge conventional wisdom and explore the frontiers of performance science.' },
            { num: '06', title: 'Community of Operators', desc: 'A tribe of self-optimizers who treat their body as their most important asset.' },
          ].map(p => (
            <div key={p.num} className="bg-pillar-card">
              <div className="bg-pillar-num">Pillar {p.num}</div>
              <div className="bg-pillar-title">{p.title}</div>
              <div className="bg-pillar-desc">{p.desc}</div>
            </div>
          ))}
        </div>
      </div>

      {/* 04 — Audience */}
      <div className="bg-page bg-chapter-break">
        <div className="bg-section-label">04 — Target Audience</div>
        <div className="bg-section-title">Who We're<br/>Talking To</div>
        <div className="bg-section-rule" />
        <div className="bg-audience-grid">
          {[
            { name: 'The Competitive Athlete', desc: 'HYROX competitors, functional fitness athletes, obstacle racers — people who train to win.' },
            { name: 'The Biohacker', desc: 'Self-quantifiers who track HRV, blood glucose, sleep cycles, and peptide protocols.' },
            { name: 'The Longevity Seeker', desc: 'Athletes 30–55 actively investing in healthspan — peptides, supplements, DEXA scans.' },
          ].map(a => (
            <div key={a.name} className="bg-audience-card">
              <div className="bg-audience-name">{a.name}</div>
              <div className="bg-audience-desc">{a.desc}</div>
            </div>
          ))}
        </div>
      </div>

      {/* 05 — Visual Identity */}
      <div className="bg-page bg-chapter-break">
        <div className="bg-section-label">05 — Visual Identity</div>
        <div className="bg-section-title">Color &<br/>Typography</div>
        <div className="bg-section-rule" />
        <h3 className="bg-h3">Primary Color Palette</h3>
        <div className="bg-color-grid">
          {[
            { name: 'Ninja Black', hex: '#0A0A0A', use: 'Primary background, hero sections', bg: '#0A0A0A' },
            { name: 'Strike Red', hex: '#D42B2B', use: 'CTAs, accents, emphasis', bg: '#D42B2B' },
            { name: 'Pure White', hex: '#FFFFFF', use: 'Site background, article body', bg: '#FFFFFF', border: true },
            { name: 'Steel Gray', hex: '#F5F5F5', use: 'Section backgrounds, cards', bg: '#F5F5F5' },
          ].map(c => (
            <div key={c.name} className="bg-color-swatch">
              <div className="bg-color-block" style={{ background: c.bg, border: c.border ? '1px solid #E0E0E0' : 'none' }} />
              <div className="bg-color-info">
                <div className="bg-color-name">{c.name}</div>
                <div className="bg-color-hex">{c.hex}</div>
                <div className="bg-color-use">{c.use}</div>
              </div>
            </div>
          ))}
        </div>

        <h3 className="bg-h3">Typography System</h3>
        <div className="bg-type-sample">
          <div className="bg-type-label">Display / Headings — Oswald Bold (700)</div>
          <div style={{ fontFamily: 'Oswald,sans-serif', fontSize: 48, fontWeight: 700, textTransform: 'uppercase', letterSpacing: -0.5, color: '#0A0A0A', lineHeight: 1 }}>NinjAthlete</div>
        </div>
        <div className="bg-type-sample">
          <div className="bg-type-label">Body / Paragraphs — Inter Regular (400)</div>
          <div style={{ fontFamily: 'Inter,sans-serif', fontSize: 16, color: '#333', lineHeight: 1.8 }}>Science-backed biohacking protocols, peptide therapy guides, HYROX training, and performance tools for athletes who refuse to settle for average.</div>
        </div>
      </div>

      {/* 06 — Logo */}
      <div className="bg-page bg-chapter-break">
        <div className="bg-section-label">06 — Logo Usage</div>
        <div className="bg-section-title">Brand Mark<br/>Rules</div>
        <div className="bg-section-rule" />
        <div className="bg-logo-grid">
          <div>
            <div className="bg-logo-box dark">
              <span className="bg-logo-text" style={{ color: '#fff' }}>Ninj<span style={{ color: '#D42B2B' }}>A</span>thlete</span>
            </div>
            <p style={{ fontSize: 12, color: '#6B6B6B', marginTop: 8, textAlign: 'center' }}>Preferred: Dark Background</p>
          </div>
          <div>
            <div className="bg-logo-box">
              <span className="bg-logo-text" style={{ color: '#0A0A0A' }}>Ninj<span style={{ color: '#D42B2B' }}>A</span>thlete</span>
            </div>
            <p style={{ fontSize: 12, color: '#6B6B6B', marginTop: 8, textAlign: 'center' }}>Acceptable: Light Background</p>
          </div>
        </div>
        <div className="bg-highlight"><strong>The "A" matters.</strong> The capital A in NinjAthlete is intentional — it bridges the two words visually and linguistically. It must always be capitalized.</div>
      </div>

      {/* 07 — Voice & Tone */}
      <div className="bg-page bg-chapter-break">
        <div className="bg-section-label">07 — Voice & Tone</div>
        <div className="bg-section-title">How We<br/>Speak</div>
        <div className="bg-section-rule" />
        <table className="bg-voice-table">
          <thead><tr><th>We Are</th><th>We Are Not</th></tr></thead>
          <tbody>
            {[['Authoritative','Arrogant or dismissive'],['Science-backed','Academic or boring'],['Motivating','Hype or empty cheerleading'],['Bold','Offensive or alienating'],['Direct','Blunt or cold'],['Accessible','Dumbed down'],['Stoic','Emotionless']].map(([a,b]) => (
              <tr key={a}><td>{a}</td><td>{b}</td></tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* 08 — Content Strategy */}
      <div className="bg-page bg-chapter-break">
        <div className="bg-section-label">08 — Content Strategy</div>
        <div className="bg-section-title">Content Pillars<br/>& Topics</div>
        <div className="bg-section-rule" />
        <div className="bg-topic-grid">
          {['Peptide Therapy','HYROX Training','Biohacking','Longevity Science','Nutrition Protocols','Recovery Optimization','Performance Tools','Mindset & Discipline','Supplements'].map(t => (
            <div key={t} className="bg-topic-chip">{t}</div>
          ))}
        </div>
      </div>

      {/* 09 — Taglines */}
      <div className="bg-page bg-chapter-break">
        <div className="bg-section-label">09 — Brand Messaging</div>
        <div className="bg-section-title">Taglines &<br/>Brand Phrases</div>
        <div className="bg-section-rule" />
        <h3 className="bg-h3">Primary Taglines</h3>
        <ul className="bg-taglines-list">
          {['Optimize Everything. Excel Always.','The Unseen Edge.','Gear Up. Show Up. Optimize Everything.','Science. Discipline. Mastery.','Built for Athletes Who Refuse to Settle.'].map(t => (
            <li key={t}>{t}</li>
          ))}
        </ul>
      </div>

      {/* 10 — Influencer Outreach */}
      <div className="bg-page bg-chapter-break">
        <div className="bg-section-label">10 — Outreach Copy</div>
        <div className="bg-section-title">Influencer<br/>Outreach</div>
        <div className="bg-section-rule" />
        <div className="bg-copy-card">
          <div className="bg-copy-header">
            <div className="bg-copy-title">Version A — DM / Short Form</div>
            <div className="bg-copy-tag">Instagram / Twitter</div>
          </div>
          <div className="bg-copy-body">
            <p>Hey [Name] — I've been following your content for a while and your approach to [training/recovery/biohacking] is genuinely one of the best out there.</p>
            <p>I run NinjAthlete (ninjathlete.com) — a performance science platform built for athletes who want to go deeper than the surface-level stuff.</p>
            <p>I'd love to explore a collab — whether that's an affiliate arrangement, a product feature, or co-created content. We take care of our partners.</p>
          </div>
        </div>
        <div className="bg-copy-card">
          <div className="bg-copy-header">
            <div className="bg-copy-title">Version B — Email Outreach</div>
            <div className="bg-copy-tag">Full Email</div>
          </div>
          <div className="bg-copy-body">
            <p><strong>Subject: NinjAthlete x [Their Name] — Built for Athletes Like You</strong></p>
            <p>We're selectively partnering with creators who share our ethos: <em>discipline over motivation, evidence over opinion, mastery over mediocrity.</em></p>
            <p><strong>What a partnership looks like:</strong></p>
            <p>Affiliate commission on every reader you send our way. Co-created content with full attribution. Early access to new guides and tools before public launch.</p>
          </div>
        </div>
      </div>

      {/* 12 — Do's/Don'ts */}
      <div className="bg-page bg-chapter-break">
        <div className="bg-section-label">12 — Brand Rules</div>
        <div className="bg-section-title">Do's &<br/>Don'ts</div>
        <div className="bg-section-rule" />
        <div className="bg-pillars-grid">
          <div className="bg-pillar-card" style={{ borderColor: 'transparent', borderLeft: '4px solid #2E7D32' }}>
            <div className="bg-pillar-num" style={{ color: '#2E7D32' }}>Always Do</div>
            <div className="bg-pillar-desc" style={{ lineHeight: 2 }}>
              Capitalize NinjAthlete with capital A<br/>
              Lead with evidence and science<br/>
              Use Oswald for all display headings<br/>
              Include source citations in long-form content<br/>
              Write as if talking to a serious athlete<br/>
              Add schema markup to all published articles
            </div>
          </div>
          <div className="bg-pillar-card" style={{ borderColor: 'transparent', borderLeft: '4px solid #C62828' }}>
            <div className="bg-pillar-num" style={{ color: '#C62828' }}>Never Do</div>
            <div className="bg-pillar-desc" style={{ lineHeight: 2 }}>
              Write "ninja athlete" as two words<br/>
              Make medical claims or prescriptive advice<br/>
              Use unverified broscience as fact<br/>
              Write hype-only content with no substance<br/>
              Recommend products you haven't verified<br/>
              Use fonts outside the defined type system
            </div>
          </div>
        </div>
      </div>

      {/* Partnership CTA */}
      <div className="bg-partner-cta" data-testid="partnership-cta-section">
        <div className="bg-cta-label">Work With Us</div>
        <div className="bg-cta-title">Ready to Partner<br/>with NinjAthlete?</div>
        <div className="bg-cta-divider" />
        <p className="bg-cta-sub">
          We partner with creators, coaches, and brands who share our ethos — discipline over motivation, evidence over opinion, mastery over mediocrity. Affiliate arrangements, co-created content, and early tool access available.
        </p>
        <Link to="/contact" className="bg-cta-btn" data-testid="partnership-cta-btn">
          Request a Partnership
        </Link>
      </div>

      {/* Footer */}
      <div className="bg-footer">
        <span style={{ color: '#D42B2B' }}>NinjAthlete</span> Brand & Content Guidelines | ninjathlete.com | Confidential — For Internal & Partner Use Only | 2025
      </div>
    </div>
  );
}
